// label wrapper takes in a recipe, and maps out all the labels based on tag
import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  Space,
  useTheme,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import { Label } from './Label'
import { DietaryWarningTag } from '../DietaryWarningTag/DietaryWarningTag'
import { Recipe } from '@library/menu-service'

type LabelWrapperProps = {
  isOutOfStock: boolean
  recipe: Recipe
}

const LabelWrapperBox = withCitrusTheme(Box, (theme) => ({
  display: Display.Flex,
  borderColor: theme.tokens.colors.White,
  borderWidth: 1.5,
  alignItems: AlignItems.Center,
  position: DisplayPosition.Absolute,
  top: 0,
  left: 0,
  transform: 'translateY(calc(-50% - 1rem))',
  zIndex: 12,
}))

export const LabelWrapper = ({ isOutOfStock, recipe }: LabelWrapperProps) => {
  const { theme } = useTheme()

  const { invalidPreference } = recipe
  const brandTag = recipe.merchandisingTags.tagline
  const recipeTag = recipe.merchandisingTags.availability

  if (isOutOfStock) {
    return (
      <LabelWrapperBox data-testid="sold-out-tag">
        <Label
          text="Sold Out"
          textColor={Color.White}
          backgroundColor={theme.tokens.colors.ColdGrey_800}
        />
      </LabelWrapperBox>
    )
  }

  if (invalidPreference) {
    return (
      <LabelWrapperBox>
        <DietaryWarningTag text={invalidPreference} />
      </LabelWrapperBox>
    )
  }

  //if no tags, return
  if (!brandTag && !recipeTag) {
    return null
  }

  return (
    <LabelWrapperBox>
      {recipeTag && (
        <>
          <Label
            text={recipeTag.name}
            backgroundColor={recipeTag.backgroundColor.light}
            textColor={recipeTag.color.light}
          />
          <Space size={1} direction="horizontal" />
        </>
      )}

      {brandTag && (
        <Label
          text={brandTag.name}
          backgroundColor={brandTag.backgroundColor.light}
          textColor={brandTag.color.light}
        />
      )}
    </LabelWrapperBox>
  )
}
